import { render, staticRenderFns } from "./CallUpdateUser.vue?vue&type=template&id=615a27d2"
import script from "./CallUpdateUser.vue?vue&type=script&lang=js"
export * from "./CallUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports